import { asyncLoad } from '@util'

export default {
  path: 'introduction',
  component: asyncLoad(() =>
    import('@components/LocalMerchant/VR/Introduction')
  )
}
